import React from "react";
import PageNotFound from "../img/404 Error-bro.png";
import { motion } from "framer-motion";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";

const Page404 = () => {
  return (
    <motion.div
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      className="page404"
      exit="exit"
    >
      <div className="image">
        <img src={PageNotFound} alt="" />
      </div>
      <div className="desc">
        <h1>404 Error</h1>
        <h1>Page Not Found</h1>
        <br />
        <br />
        <p>
          你在找尋的頁面不存在。請檢察網址是否正確，或是回到首頁重新瀏覽網站。若有疑問，請透過網頁表單或email信箱，聯絡Wilson
          Ren。Wilson Ren會在24小時內與你聯繫。
        </p>
      </div>
      <ScrollTop />
    </motion.div>
  );
};

export default Page404;
